import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { thumbUrl } from "../lib/api";

const photoPinIcon = (url, count = 1) => L.divIcon({
  className: "",
  html: `<div style="position:relative;width:40px;height:40px"><div style="width:40px;height:40px;border-radius:50%;border:3px solid white;box-shadow:0 3px 10px rgba(0,0,0,.4);overflow:hidden;background:#B5838D"><img src="${url}" style="width:100%;height:100%;object-fit:cover" loading="lazy"/></div>${count > 1 ? `<span style="position:absolute;top:-6px;right:-6px;background:#E07A5F;color:#fff;font-size:11px;font-weight:800;border-radius:9999px;min-width:19px;height:19px;display:flex;align-items:center;justify-content:center;padding:0 4px;border:2px solid white">${count}</span>` : ""}</div>`,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

const momentIcon = (voice) => L.divIcon({
  className: "",
  html: `<div style="width:24px;height:24px;border-radius:50%;background:#B5838D;display:flex;align-items:center;justify-content:center;color:white;border:2px solid white;box-shadow:0 2px 6px rgba(0,0,0,.35)">${voice
    ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/><line x1="12" x2="12" y1="19" y2="22"/></svg>'
    : '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>'}</div>`,
  iconSize: [24, 24],
  iconAnchor: [12, 12],
});

const entryImageIds = (e) => {
  const ids = [];
  if (e.photo_id) ids.push(e.photo_id);
  (e.media || []).forEach((m) => { if (m.content_type?.startsWith("image")) ids.push(m.id); });
  return ids;
};

export const PhotoPins = ({ entries, mediaUrl }) =>
  (entries || []).filter((e) => e.lat != null && e.lon != null).map((e) => {
    const ids = entryImageIds(e);
    return (
      <Marker key={`pin-${e.id}`} position={[e.lat, e.lon]} zIndexOffset={1500}
        icon={ids.length ? photoPinIcon(thumbUrl(mediaUrl(ids[0])), ids.length) : momentIcon(e.source === "voice")}>
        <Popup maxWidth={250}>
          {ids.length === 1 && <img src={thumbUrl(mediaUrl(ids[0]))} alt="Reismoment" loading="lazy" decoding="async" style={{ width: 220, borderRadius: 10, marginBottom: 6, maxHeight: 165, objectFit: "cover" }} />}
          {ids.length > 1 && (
            <span style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 4, width: 220, marginBottom: 6 }}>
              {ids.slice(0, 4).map((id, i) => (
                <span key={id} style={{ position: "relative" }}>
                  <img src={thumbUrl(mediaUrl(id))} alt="Reismoment" loading="lazy" decoding="async" style={{ width: "100%", height: 80, borderRadius: 8, objectFit: "cover", display: "block" }} />
                  {i === 3 && ids.length > 4 && (
                    <span style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,.5)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, borderRadius: 8 }}>+{ids.length - 4}</span>
                  )}
                </span>
              ))}
            </span>
          )}
          {e.text && <span style={{ display: "block", marginBottom: 4 }}>{e.text.length > 140 ? `${e.text.slice(0, 140)}…` : e.text}</span>}
          <span style={{ fontSize: 11, color: "#6B7280" }}>
            {e.location_name ? `${e.location_name} · ` : ""}
            {new Date(e.timestamp).toLocaleString("nl-BE", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}
          </span>
        </Popup>
      </Marker>
    );
  });
